"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const padLeft = (str, len, padding) => str.toString().length < len ? padLeft(`${padding}${str}`, len, padding) : str;
const friendlyDateString = date => `${padLeft(date.getMonth() + 1, 2, '0')}/${padLeft(date.getDate(), 2, '0')}/${date.getFullYear()}`;
exports.default = friendlyDateString;
//# sourceMappingURL=friendly-date-string.js.map